import React from 'react';
import { Facebook, MessageCircle, Calendar } from 'lucide-react';

const FacebookSection = () => {
  return (
    <section className="relative py-20 bg-white/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Content */}
          <div>
            <div className="flex items-center justify-center gap-3 mb-6">
              <Facebook size={40} className="text-white" />
              <h2 className="font-display text-3xl md:text-5xl font-bold text-white">
                FOLLOW US
              </h2>
            </div>
            <p className="text-2xl text-white/90 mb-6 leading-relaxed">
              Best way to contact us for fastest response & see new updates
            </p>
            <p className="text-white/70 text-lg leading-relaxed mb-8 max-w-3xl mx-auto">
              Stay connected with Atlantic Coast Tattoo on Facebook! Get the quickest responses to your inquiries, see our latest work, check availability, and stay updated with new flash designs, special offers, and studio news.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-8 max-w-2xl mx-auto">
              <div className="flex items-start gap-3 text-left">
                <MessageCircle className="text-white mt-1 flex-shrink-0" size={24} />
                <div>
                  <h3 className="text-white font-semibold mb-1">FASTEST RESPONSE TIME</h3>
                  <p className="text-white/70">Message us directly for quick replies and instant communication</p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-left">
                <Calendar className="text-white mt-1 flex-shrink-0" size={24} />
                <div>
                  <h3 className="text-white font-semibold mb-1">DAILY UPDATES</h3>
                  <p className="text-white/70">See our latest tattoo work, available slots, and studio updates</p>
                </div>
              </div>
            </div>

            <a
              href="https://www.facebook.com/atlanticcoasttattoo/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#1877F2] text-white px-8 py-4 text-sm tracking-wider hover:bg-[#1565D8] transition-colors"
            >
              <Facebook size={24} />
              VISIT OUR FACEBOOK PAGE
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FacebookSection;
